import React, { useEffect, useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { HitApi } from '../../Api/ApiHit';
import { searchProduct } from '../../constant/Constant';
import { setProducts, setBuyStockPagination, addToCart, removeFromCart, updateCartQuantity } from '../../redux/Actions/BuyStockAction';
import FilterStockBuy from './FilterStockBuy';
import toast from 'react-hot-toast';
import { getSelectedUnit } from '../../storage/Storage';
import PageHeader from '../../PageHeader/PageHeader';
import BuyStockPagination from './BuyStockPagination';

function BuyStockMaster() {
    const dispatch = useDispatch();
    const { products, cart, pagination } = useSelector((state) => state.BuyStockReducer);

    console.log("products",products);
    console.log("cart",cart);
    
    const [isLoading, setIsLoading] = useState(false);
    const [filteredProducts, setFilteredProducts] = useState([]);
    const [activeFilters, setActiveFilters] = useState({
        brand: '',
        productType: '',
        priceRange: { min: '', max: '' },
        vendor: '',
        searchText: ''
    });
    const [showCart, setShowCart] = useState(false);

    const getProducts = useCallback(async () => {
        setIsLoading(true);
        try {
            const searchObj = {
                unitIds: getSelectedUnit()?._id
            };

            // Add active filters to search object
            if (activeFilters.brand) {
                searchObj.brand = activeFilters.brand;
            }
            if (activeFilters.productType) {
                searchObj.productType = activeFilters.productType;
            }
            if (activeFilters.vendor) {
                searchObj.vendor = activeFilters.vendor;
            }
            if (activeFilters.searchText) {
                searchObj.productName = {
                    $regex: activeFilters.searchText,
                    $options: 'i'
                };
            }
            if (activeFilters.priceRange.min || activeFilters.priceRange.max) {
                const min = parseFloat(activeFilters.priceRange.min) || 0;
                const max = parseFloat(activeFilters.priceRange.max) || 999999;
                searchObj.sellPrice = {
                    $gte: min,
                    $lte: max
                };
            }

            const json = {
                page: pagination.page,
                limit: pagination.limit,
                search: searchObj
            };

            const res = await HitApi(json, searchProduct);

            if (res?.statusCode === 200) {
                const productsData = res?.data?.docs || [];
                dispatch(setProducts(productsData));
                dispatch(setBuyStockPagination({
                    total: res?.data?.totalDocs || 0,
                    page: res?.data?.page || 1,
                    limit: res?.data?.limit || pagination.limit,
                    totalPages: res?.data?.totalPages || 0
                }));
                setFilteredProducts(productsData);
            } else {
                toast.error('Failed to fetch products');
                dispatch(setProducts([]));
                setFilteredProducts([]);
            }
        } catch (error) {
            console.error("Error fetching products:", error);
            toast.error('Error fetching products');
            dispatch(setProducts([]));
            setFilteredProducts([]);
        } finally {
            setIsLoading(false);
        }
    }, [dispatch, pagination.page, pagination.limit, activeFilters]);

    // Call getProducts when pagination or filters change
    useEffect(() => {
        getProducts();
    }, [getProducts]);

    const handleFilterChange = (filters) => {
        setActiveFilters(filters);
        // Reset to page 1 when filters change
        dispatch(setBuyStockPagination({
            ...pagination,
            page: 1
        }));
    };

    const handleAddToCart = (product) => {
        dispatch(addToCart(product));
        toast.success(`${product.productName} added to cart`);
    };

    const handleRemoveFromCart = (productId) => {
        dispatch(removeFromCart(productId));
        toast.success('Item removed from cart');
    };

    const handleUpdateQuantity = (productId, quantity) => {
        if (quantity <= 0) {
            handleRemoveFromCart(productId);
        } else {
            dispatch(updateCartQuantity(productId, quantity));
        }
    };

    const getCartQuantity = (productId) => {
        const cartItem = cart.find(item => item._id === productId);
        return cartItem ? cartItem.quantity : 0;
    };

    const isInCart = (productId) => {
        return cart.some(item => item._id === productId);
    };

    const formatCurrency = (amount) => {
        if (amount === null || amount === undefined || amount === '' || isNaN(amount)) {
            return '₹0.00';
        }
        const numAmount = typeof amount === 'string' ? parseFloat(amount) : amount;
        if (isNaN(numAmount)) return '₹0.00';
        return `₹${numAmount.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
    };

    const calculateCartTotal = () => {
        return cart.reduce((total, item) => {
            const price = item.sellPrice || item.mrp || 0;
            return total + (price * item.quantity);
        }, 0);
    };

    const ProductCard = ({ product }) => {
        const quantity = getCartQuantity(product._id);
        const inCart = isInCart(product._id);

        return (
            <div className="border rounded-lg overflow-hidden group hover:shadow-lg transition-shadow duration-300">
                {/* Product Image */}
                <div className="relative overflow-hidden h-40">
                    <img
                        src={product.productImageUrl || 'https://img8.hkrtcdn.com/39077/prd_3907647-MuscleBlaze-Biozyme-Performance-Whey-4.4-lb-Chocolate-Hazelnut_o.jpg'}
                        alt={product.productName}
                        className="w-full h-full object-contain"
                        onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = 'https://img8.hkrtcdn.com/39077/prd_3907647-MuscleBlaze-Biozyme-Performance-Whey-4.4-lb-Chocolate-Hazelnut_o.jpg';
                        }}
                    />

                    {/* Discount Badge */}
                    {product.sellPriceDis > 0 && (
                        <div className="absolute top-2 left-2">
                            <span className="bg-green-600 text-white text-xs font-bold px-2 py-1 rounded">
                                {Math.round(product.sellPriceDis)}% OFF ON MRP
                            </span>
                        </div>
                    )}
                </div>

                {/* Product Details */}
                <div className="p-3">
                    {/* Brand and Usage Type */}
                    <div className="flex items-center justify-between mb-1">
                        {product.brand && (
                            <p className="text-xs text-gray-500 uppercase font-medium">
                                {product.brand}
                            </p>
                        )}
                        {product.vendor && (
                            <span className={`text-xs font-semibold px-2 py-0.5 rounded ${
                                product.vendor.toLowerCase() === 'professional'
                                    ? 'bg-indigo-100 text-indigo-700'
                                    : 'bg-emerald-100 text-emerald-700'
                            }`}>
                                {product.vendor}
                            </span>
                        )}
                    </div>

                    {/* Product Name */}
                    <h3 className="text-sm font-normal text-gray-900 mb-1 line-clamp-2 min-h-[32px] leading-snug">
                        {product.productName}
                    </h3>

                    {/* Rating */}
                    <div className="flex items-center gap-1 mb-1.5">
                        {[1, 2, 3, 4, 5].map((star) => (
                            <svg
                                key={star}
                                className={`w-3 h-3 ${star <= 4 ? 'text-yellow-400 fill-yellow-400' : 'text-gray-300 fill-gray-300'}`}
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 20 20"
                                fill="currentColor"
                            >
                                <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                            </svg>
                        ))}
                        <span className="text-xs text-gray-500 ml-1">(4.0)</span>
                    </div>

                    {/* Pricing */}
                    <div className="mb-2">
                        <div className="flex items-center gap-2">
                            <span className="text-base font-bold text-gray-900">
                                {formatCurrency(product.sellPrice)}
                            </span>
                            {product.mrp !== product.sellPrice && (
                                <span className="text-sm text-gray-400 line-through">
                                    {formatCurrency(product.mrp)}
                                </span>
                            )}
                        </div>
                    </div>

                    {/* Add to Cart Button */}
                    {!inCart ? (
                        <button
                            onClick={() => handleAddToCart(product)}
                            className="w-full bg-white border-[1px] border-gray-300 text-gray-900 hover:bg-gradient-to-r from-indigo-600 to-purple-600 hover:text-white font-medium py-2 px-4 rounded transition-colors duration-200 text-sm"
                        >
                            Add To Cart
                        </button>
                    ) : (
                        <div className="flex items-center justify-center gap-3 border-[1px] border-gray-300 rounded py-2 hover:bg-gradient-to-r from-indigo-600 to-purple-600  hover:text-white">
                            <button
                                onClick={() => handleUpdateQuantity(product._id, quantity - 1)}
                                className="  hover:text-white font-bold px-3 transition-colors"
                            >
                                −
                            </button>
                            <span className="font-bold text-base min-w-[20px] text-center  hover:text-white">{quantity}</span>
                            <button
                                onClick={() => handleUpdateQuantity(product._id, quantity + 1)}
                                className=" font-bold px-3 hover:text-white transition-colors"
                            >
                                +
                            </button>
                        </div>
                    )}
                </div>
            </div>
        );
    };

    return (
        <div className="min-h-screen bg-gray-50">
            <div className="px-5 bg-white border-b border-gray-200">
                <PageHeader
                    title="Buy Stock"
                    description="Browse and purchase products for your inventory"
                />
            </div>

            {/* Cart Badge */}
            {cart.length > 0 && (
                <div className="fixed top-20 right-5 z-50">
                    <button
                        onClick={() => setShowCart(!showCart)}
                        className="relative bg-gradient-to-r from-indigo-600 to-purple-600 text-white p-4 rounded-full shadow-lg hover:shadow-xl hover:from-indigo-700 hover:to-purple-700 transition-all transform hover:scale-110"
                    >
                        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z" />
                        </svg>
                        <span className="absolute -top-2 -right-2 bg-gradient-to-r from-pink-500 to-rose-500 text-white text-xs font-bold rounded-full h-6 w-6 flex items-center justify-center shadow-md animate-pulse">
                            {cart.length}
                        </span>
                    </button>
                </div>
            )}

            {/* Cart Sidebar */}
            {showCart && (
                <>
                    {/* Overlay */}
                    <div
                        className="fixed inset-0 bg-black bg-opacity-50 z-40"
                        onClick={() => setShowCart(false)}
                    ></div>

                    <div className="fixed top-0 right-0 h-full w-96 bg-white shadow-2xl z-50 overflow-y-auto">
                        <div className="p-4 border-b sticky top-0 bg-white z-10">
                            <div className="flex items-center justify-between">
                                <h2 className="text-xl font-bold">Cart ({cart.length})</h2>
                                <button
                                    onClick={() => setShowCart(false)}
                                    className="text-gray-500 hover:text-gray-700"
                                >
                                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                    </svg>
                                </button>
                            </div>
                        </div>

                        <div className="p-4">
                            {cart.length === 0 ? (
                                <p className="text-center text-gray-500">Your cart is empty</p>
                            ) : (
                                <>
                                    {cart.map(item => (
                                        <div key={item._id} className="flex gap-3 mb-4 pb-4 border-b">
                                            <div className="w-20 h-20 bg-gray-100 rounded-lg flex-shrink-0">
                                                {item.productImageUrl ? (
                                                    <img
                                                        src={item.productImageUrl}
                                                        alt={item.productName}
                                                        className="w-full h-full object-cover rounded-lg"
                                                    />
                                                ) : (
                                                    <div className="w-full h-full flex items-center justify-center">
                                                        <span className="text-2xl">📦</span>
                                                    </div>
                                                )}
                                            </div>
                                            <div className="flex-1">
                                                <h4 className="font-semibold text-sm mb-1 line-clamp-2">{item.productName}</h4>
                                                <p className="text-xs text-gray-500 mb-2">{item.brand}</p>
                                                <div className="flex items-center justify-between">
                                                    <span className="font-bold text-gray-900">
                                                        {formatCurrency(item.sellPrice || item.mrp)}
                                                    </span>
                                                    <div className="flex items-center gap-2">
                                                        <button
                                                            onClick={() => handleUpdateQuantity(item._id, item.quantity - 1)}
                                                            className="w-6 h-6 flex items-center justify-center bg-gray-200 hover:bg-gray-300 rounded"
                                                        >
                                                            -
                                                        </button>
                                                        <span className="text-sm font-semibold">{item.quantity}</span>
                                                        <button
                                                            onClick={() => handleUpdateQuantity(item._id, item.quantity + 1)}
                                                            className="w-6 h-6 flex items-center justify-center bg-gray-200 hover:bg-gray-300 rounded"
                                                        >
                                                            +
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}

                                    <div className="border-t pt-4 mt-4 sticky bottom-0 bg-white">
                                        <div className="flex justify-between items-center mb-4">
                                            <span className="text-lg font-bold text-gray-700">Total:</span>
                                            <span className="text-2xl font-bold bg-gradient-to-r from-indigo-600 to-purple-600 bg-clip-text text-transparent">
                                                {formatCurrency(calculateCartTotal())}
                                            </span>
                                        </div>
                                        <button className="w-full bg-gradient-to-r from-emerald-500 to-teal-500 hover:from-emerald-600 hover:to-teal-600 text-white font-bold py-3 px-4 rounded-lg transition-all shadow-lg hover:shadow-xl uppercase tracking-wide transform hover:-translate-y-0.5">
                                            Proceed to Checkout
                                        </button>
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                </>
            )}

            {/* Main Content - Sidebar + Products */}
            <div className="flex gap-0">
                {/* Left Sidebar - Filters */}
                <div className="w-64 flex-shrink-0 bg-white border-r border-gray-200 sticky top-0 h-screen overflow-y-auto">
                    <FilterStockBuy
                        onFilterChange={handleFilterChange}
                        products={products}
                    />
                </div>

                {/* Right Content - Products Grid */}
                <div className="flex-1 ">
                    <div className="p-6 max-w-[1600px] mx-auto bg-white">
                        {/* Loading State */}
                        {isLoading && (
                            <div className="flex justify-center items-center h-64">
                                <div className="text-lg">Loading products...</div>
                            </div>
                        )}

                        {/* No Products */}
                        {!isLoading && filteredProducts.length === 0 && (
                            <div className="text-center py-12">
                                <p className="text-gray-500 text-lg">No products found</p>
                            </div>
                        )}

                        {/* Products Grid */}
                        {!isLoading && filteredProducts.length > 0 && (
                            <>
                                <div className="mb-4 flex items-center justify-between">
                                    <span className="text-sm text-gray-600">
                                        Showing {((pagination.page - 1) * pagination.limit) + 1} - {Math.min(pagination.page * pagination.limit, pagination.total)} of {pagination.total} products
                                    </span>
                                </div>
                                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 mb-6">
                                    {filteredProducts.map(product => (
                                        <ProductCard key={product._id} product={product} />
                                    ))}
                                </div>

                                {/* Pagination */}
                                {pagination.totalPages > 1 && (
                                    <div className="mt-6">
                                        <BuyStockPagination />
                                    </div>
                                )}
                            </>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default BuyStockMaster;
